const Footer: React.FC = () => <div data-testid="footer" />;

export default Footer;
